import { CONFIG } from './config'

export const VALIDGUESSES = [
  'bagel',
  'delis',
  'parks',
  'buoys',
  'hikes',
  'south',
  'wines',
  'beach',
  'farms',
  'moses',
  'kayak',
  'music',
  'towel',
  'ferry',
  'oheka',
  'visit',
  'billy',
  'dunes',
  'sails',
  'chill',
  'pizza',
  'north',
  'train',
  'whale',
  'sport',
  'fresh',
  'jones',
  'shell',
  'forks',
  'slice',
  'upton',
  'inlet',
  'taste',
  'waves',
  'coram',
  'relax',
  'sound',
  'grass',
  'float',
  'local',
  'seals',
  'yacht',
  'drink',
  'ridge',
  'shore',
  'bikes',
  'grape',
  'coral',
  'sandy',
  'trees',
  'isles',
  'foxes',
  'songs',
  'towns',
  'lohan',
  'crabs',
  'eaten',
  'light',
  'piers',
  'coast',
  'spies',
  'hotel',
  'islip',
  'arena',
  'tides',
  'outlet',
  'salty',
  'conch',
  'vines',
  'canoe',
  'berry',
  'trail',
  'clams',
  'water',
  'fruit',
  'bluffs',
  'travel',
  'ocean',
  'ducks',
  'sight',
  'horse',
  'boats',
  'foods',
  'shark',
  'canal',
  'ryder',
  'docks',
  'shops',
  'lakes',
  'coves'
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
